import {isMobile} from '../../utils/browserDetect'

export type VideoFacingMode = 'user' | 'environment'

class VideoStreamParams {
    aspectRatio = 16 / 9
    deviceId: any
    facingMode: any

    // Явный facingMode имеет приоритет над deviceId: используется как fallback,
    // когда фронтальная камера по deviceId-only не открывается (чёрный кадр
    // или NotReadableError на части Android).
    constructor(videoDeviceId?: string, facingMode?: VideoFacingMode) {
        if (facingMode) {
            this.facingMode = {exact: facingMode}
        } else if (videoDeviceId) {
            this.deviceId = {exact: videoDeviceId}
        } else {
            this.facingMode = {ideal: 'user'}
        }
    }
}

class DesktopVideoStreamParams extends VideoStreamParams {
    width = {ideal: 1920}
    height = {ideal: 1080}
    frameRate = {ideal: 60}

    constructor(videoDeviceId?: string, facingMode?: VideoFacingMode) {
        super(videoDeviceId, facingMode)
    }
}

export class VideoUtils {
    static async attachLocalVideo(
        videoDeviceId?: string,
        audioDeviceId?: string,
        options?: { videoOnly?: boolean, audioOnly?: boolean, videoFacingMode?: VideoFacingMode }
    ): Promise<MediaStream> {
        let video: MediaTrackConstraints | boolean = false
        if (!options?.audioOnly) {
            // For mobile Safari, it's better to be gentle (don't set desired constraints, otherwise video doesn't transmit)
            video = isMobile()
                ? new VideoStreamParams(videoDeviceId, options?.videoFacingMode)
                : new DesktopVideoStreamParams(videoDeviceId, options?.videoFacingMode)
        }

        let audio: MediaTrackConstraints | boolean = false
        if (!options?.videoOnly) {
            audio = {
                ...(audioDeviceId ? { deviceId: { exact: audioDeviceId } } : {}),
                echoCancellation: true,
                noiseSuppression: true,
                autoGainControl: true,
            }
        }

        return await navigator.mediaDevices.getUserMedia({ video, audio })
    }
}
